import { useLocation } from 'react-router';

export const useIsMatchComponent = () => {
  const { pathname, search } = useLocation();

  return pathname.includes('/matches/') && !search.length;
};
